import type { RouteRecordRaw } from "vue-router";

export const reportRoutes: RouteRecordRaw[] = [
    {
        path: "/reports",
        children: [
            // TODO: add report views
            {
                path: "index",
                name: "Reports",
                component: () => import("./views/ReportsScreen.vue"),
                meta: { requiresAuth: true },
            },
        ],
    },
];
